import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import {localDateShort, localFullDateLong, isToday, getRelativeDay, getRelativeDayURI, isYesterday} from 'utils/LocalDateTimeHelper';
import config from 'config';
import { canonicalLink, metaDescription } from 'utils/seoUtils';

import DatePicker from 'modules/Common/components/DatePicker';
import Tabs from 'modules/Common/components/Tabs';
import RacecardsMeetingSummary from '../components/HorseRacingRacecardsMeetingSummary';

require("./HorseRacingResultsForDate.scss");

export default class HorseRacingResultsForDate extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    date: PropTypes.string,
    meetingsByDate: PropTypes.object.isRequired,
    raceType: PropTypes.string
  };

  render() {
    var title;
    const convertToday = true;
    const convertYesterday = true;

    // build the date navigation array
    const dateNav = [], date = new Date();
    for (let i = 0; i < 7; i++) {
      const urlPart = getRelativeDayURI(date, 0, {convertToday, convertYesterday});
      const rawURLPart = getRelativeDayURI(date, 0, {convertToday: false, convertYesterday: false});
      let alternatives = [];
      if(urlPart != rawURLPart)
      {
        alternatives = [{href: `/racing/results${rawURLPart}`, isIndex: isToday(date)}];
      }
      dateNav.push({ href: `/racing/results${urlPart}`,
                    text: localDateShort(date, {convertToday, convertYesterday}),
                    isIndex: isToday(date),
                    alternatives});
      date.setDate(date.getDate() - 1);
    }

    const racecardsDate = this.props.date;
    const meetings = this.props.meetingsByDate[racecardsDate] == null ? null : this.props.meetingsByDate[racecardsDate].meetings;

    if(isToday(racecardsDate)){
      title = 'Today\'s Results'
    }
    else if (isYesterday(racecardsDate)){
      title = 'Yesterday\'s Results'
    }
    else{
      title = `${localFullDateLong(racecardsDate)} Results`;
    }

    const summaryBaseProps = {
      date: racecardsDate,
      dateIncrement: -1,
      // component is used on both results and racecards, so need to tell it this is the result page
      "result-racecard": "result"
    };

    var {link = []} =  canonicalLink(this.props.routes, {date: getRelativeDay(racecardsDate, 0, {convertToday, convertYesterday})});
    if(!isToday(racecardsDate)){
      link.push({
        rel: "next",
        href: `${config.canonicalBase}/racing/results${getRelativeDayURI(racecardsDate, 1, {convertToday, convertYesterday})}`
      });
    }

    link.push({
      rel: "prev",
      href: `${config.canonicalBase}/racing/results${getRelativeDayURI(racecardsDate, -1, {convertToday, convertYesterday})}`
    });

    const courseList = [];

    if (meetings === undefined || meetings === null) {
      return (
        <div className="hr-racing-racecards">
          <p>Failed to load results.</p>
        </div>
        )
    }

    meetings.forEach(({ meeting_summary: { course: { name = ''} = {}}} = {}) => courseList.push(name));
    const courses = courseList.join(', ');
    const metaDesc = `Results and video replays from meetings including ${courses}`;

    const helmetProps = {
      ...metaDescription(metaDesc),
      ...{link}
    }

    return (
      <div className="hr-racing-racecards">
        <MetaDataWrapper title={title} helmetProps={{...helmetProps}}/>
        <div className="hr-racing-racecards-header-container">
          <div className="hr-racing-racecards-header-title">
            <div className="hr-racing-racecards-header-title-text">
              <h1 className="page-main-title">{title}</h1>
            </div>
            <div className="hr-racing-racecards-header-title-date-picker">
              <DatePicker urlBase="/racing/results" date={racecardsDate}/>
            </div>
          </div>
          <Tabs tabs={dateNav}/>
        </div>
        <section className="hr-racing-content">
          {
            meetings && meetings.length > 0 ?
            <ul className="meetings">
              {meetings.map(meeting => (
                <li key={meeting.meeting_summary.meeting_reference.id}>
                  <RacecardsMeetingSummary
                    meeting={meeting}
                    {...summaryBaseProps}
                  />
                </li>
              ))}
            </ul>
          :
            <div className="hr-racing-racecards-none">
              <p>No meetings found</p>
            </div>
          }
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingResultsForDate.js